import {Month} from "./month";

export const MonthName: { [key in Month]: string } = {
  [Month.JANUARI]: 'Januari',
  [Month.FEBRUARI]: 'Februari',
  [Month.MAART]: 'Maart',
  [Month.APRIL]: 'April',
  [Month.MEI]: 'Mei',
  [Month.JUNI]: 'Juni',
  [Month.JULI]: 'Juli',
  [Month.AUGUSTUS]: 'Augustus',
  [Month.SEPTEMBER]: 'September',
  [Month.OKTOBER]: 'Oktober',
  [Month.NOVEMBER]: 'November',
  [Month.DECEMBER]: 'December'
}
